module.exports = __webpack_public_path__ + "img/16d002-07.f3d9758b.png";